module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "ChTitle",
    attrs: {
      "id": "ch20"
    }
  }, [_c('a', {
    attrs: {
      "id": "ch20aa"
    }
  }), _c('a', {
    attrs: {
      "id": "ch20a"
    }
  }), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#rch20"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_c('i', [_vm._v("MICHIN SAEKKI!")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_c('i', [_vm._v("Translated into English, these international insults may sound silly, but trust us: do not say them in their native lands!")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("G")]), _c('b', [_c('i', [_vm._v("OSPOD ODIN DA TA PRATI")]), _vm._v("!")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("(Bulgarian)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Meaning")]), _vm._v(": “Go to h*ll!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Literally")]), _vm._v(": “God sends you to the fire!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("FANTONG")]), _vm._v("!")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("(Mandarin)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Meaning:")]), _vm._v(" “Useless!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Literally:")]), _vm._v(" “Rice bucket!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("BACHE SHEYTOON")]), _vm._v("!")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("(Farsi)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Meaning:")]), _vm._v(" “Grow up!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Literally:")]), _vm._v(" “You Satan child!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("CON COMME LA BALA")]), _vm._v("!")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("(French)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Meaning:")]), _vm._v(" “Very stupid!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Literally:")]), _vm._v(" “Stupid like a broom!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("GROZNI SI KATO SALATA")]), _vm._v("!")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("(Bulgarian)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Meaning: “You’re ugly!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Literally: “You look like a salad!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("NAMEH TEN-NO")]), _vm._v("!")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("(Japanese)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Meaning:")]), _vm._v(" “You want to fight!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Literally:")]), _vm._v(" “What are you licking?”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("DRECKSCLEUDER")]), _vm._v("!")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("(German)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Meaning:")]), _vm._v(" “Potty mouth!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Literally:")]), _vm._v(" “Dirt slingshot!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("YA NA’AL")]), _vm._v("!")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("(Hebrew)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Meaning:")]), _vm._v(" “You idiot!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Literally:")]), _vm._v(" “You shoe!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("MICHIN SAEKKI")]), _vm._v("!")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("(Korean)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Meaning:")]), _vm._v(" “Nutcase!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Literally:")]), _vm._v(" “Crazy animal baby!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("GEWADEE MASTAWCHI")]), _vm._v("!")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("(Kurdish)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Meaning:")]), _vm._v(" “Sleazebag!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Literally:")]), _vm._v(" “Yogurt pimp!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("NI SHI SHENME DONGXI")]), _vm._v("!")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("(Mandarin)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Meaning:")]), _vm._v(" “You’re inhuman!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Literally:")]), _vm._v(" “What kind of object are you!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("SUTKI PALA")]), _vm._v("!")]), _vm._v(" (Polish)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Meaning:")]), _vm._v(" “Chill out!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Literally:")]), _vm._v(" “Your nipples are burning!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("AIZVER ZAUNAS")]), _vm._v("!")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("(Latvian)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Meaning:")]), _vm._v(" “Shut up!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Literally:")]), _vm._v(" “Close your gills!”")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center7"
  }, [_c('span', [_c('b', [_vm._v("When heated, 2 Tbsp. of water convert into enough steam to fill a 12-gallon container.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf839d90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter020.vue
// module id = 138
// module chunks = 0